var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":_vm.title,"items":_vm.items,"doc":_vm.doc,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }